<template>
	<form class="main-wrapper mt-4">
		<CRow>
			<CCol md="12">
				<h4>Select type plan for Com7</h4>
			</CCol>
			<CCol md="5">
				<BaseDropDown
					v-model="$v.typePlan.$model"
					:options="TYPE_PLAN_LIST"
					:is-valid="!$v.typePlan.$error"
					:invalid-feedback="$t('global.error.required')"
					label="name"
					label-drop-down="Select type plan *"
					placeholder="Select type plan"
				/>
			</CCol>
			<CCol md="12">
				<span class="typo-body-2 color-black-45 ">{{ promotionType }}</span>
			</CCol>
		</CRow>
		<hr class="my-4">
		<CRow>
			<CCol md="12">
				<h4>Default installment plan</h4>
				<span class="typo-body-2 color-black-45">Create installment plans and condition such as interest rate, payments term, and campaign code for all products</span>
			</CCol>
			<CCol md="12">
				<CInput
					v-model.trim="$v.planName.$model"
					label="Installmemt plan name (for back office)*"
					:is-valid="!$v.planName.$error && null"
					:invalid-feedback="$t('global.error.required')"
				/>
			</CCol>
			<CCol md="4">
				<CInput
					v-model.trim="$v.supplierId.$model"
					:label="supplierLabel"
					:is-valid="!$v.supplierId.$error && null"
					maxlength="4"
					:invalid-feedback="!$v.supplierId.$model ? $t('global.error.required') : 'Allow only number 4 digits'"
				/>
			</CCol>
			<CCol md="4">
				<CInput
					v-model.trim="$v.productId.$model"
					:label="productLabel"
					:is-valid="!$v.productId.$error && null"
					maxlength="4"
					:invalid-feedback="!$v.productId.$model ? $t('global.error.required') : 'Allow only number 4 digits'"
				/>
			</CCol>
		</CRow>
		<hr class="my-4">
		<CRow>
			<CCol md="12">
				<h4>Available SKUs</h4>
				<span class="typo-body-2 color-black-45">
					Set available SKUs for the installment plans above by specifying SKU or brand.
					Can't add SKU or brand thay have already been used in other plans.
				</span>
			</CCol>
			<CCol md="12" class="d-flex">
				<div
					v-for="{value, label} in AVAILABLE_SKU_OPTIONS"
					:key="`available-sku-${value}`"
					class="mr-4"
				>
					<CInputRadio
						:label="label"
						:value="value"
						:checked="isAllCategory === value"
						:inline="true"
						class="mt-3"
						custom
						@update:checked="handleChooseOptions(value)"
					/>
				</div>
			</CCol>
			<CRow v-if="!isAllCategory">
				<CCol md="12" class="d-flex justify-content-between mt-4 align-items-center">
					<div>
						<div class="label">Available for categories</div>
						<span class="typo-body-2 color-black-45">
							Set this plan to available for specific categories.
						</span>
					</div>
					<div>
						<CButton
							color="secondary"
							class="w-100"
							@click="$refs['modal-category'].open()"
						>
							Edit main category
						</CButton>
					</div>
				</CCol>
				<CCol md="12" class="d-flex justify-content-between mt-4 align-items-center">
					<div class="label">
						Exclude SKU
					</div>
					<div>
						<CButton
							color="secondary"
							class="w-100"
							@click="$refs['modal-sku'].open()"
						>
							Edit SKU
						</CButton>
					</div>
				</CCol>
			</CRow>
		</CRow>
		<hr class="my-4">
		<CRow class="mb-2">
			<CCol md="12">
				<CRow>
					<CCol md="9">
						<h4>{{ title }}</h4>
						<span class="typo-body-2 color-black-45">{{ description }}</span>
						<div class="typo-body-2 color-black-45 pt-2">
							Promotion type 01 : ใช้เฉพาะผ่อน 0%<br>
							Promotion type 02 : ใช้เฉพาะผ่อนอัตราดอกเบี้ยปกติลูกค้าจ่าย 0.74%<br>
							Promotion type 03 : ใช้เฉพาะผ่อนอัตราดอกเบี้ยพิเศษลูกค้าจ่าย 0.59%<br>
						</div>
					</CCol>
				</CRow>
			</CCol>
			<CCol md="4">
				<div class="form-group mt-3">
					<BaseInputNumber
						v-model="$v.localInterest.$model"
						:is-valid="!$v.localInterest.$error"
						:invalid-feedback="$t('global.error.required')"
						:decimal-scale="2"
						label="Interest rate*"
						append-text="%"
					/>
				</div>
			</CCol>
			<CCol md="4">
				<div class="form-group mt-3">
					<BaseInputNumber
						v-model="$v.localPeriod.$model"
						:is-valid="!$v.localPeriod.$error"
						invalid-feedback="Month must be greater than 0"
						class="input-period"
						label="Payment term*"
						append-text="Month"
					/>
				</div>
			</CCol>
			<CCol md="12">
				<hr class="my-4">
			</CCol>
			<CCol md="12">
				<h4>Order value</h4>
				<div class="typo-body-2 color-black-45">
					<span>
						Set min-max of the purchase order value for this plan, if any.
					</span>
				</div>
			</CCol>
			<CCol md="4">
				<div class="form-group mt-3">
					<BaseInputNumber
						id="minOrder"
						v-model="localMinOrder"
						:decimal-scale="2"
						label="Minimum order"
						prepend-text="฿"
						text-align="right"
						placeholder="0.00"
						allow-null-value
					/>
				</div>
			</CCol>
			<CCol md="4">
				<div class="form-group mt-3">
					<BaseInputNumber
						id="maxOrder"
						v-model="localMaxOrder"
						:decimal-scale="2"
						:is-valid="!$v.localMaxOrder.$error"
						:invalid-feedback="maxOrderErrorMessage"
						label="Maximum order"
						prepend-text="฿"
						text-align="right"
						placeholder="0.00"
						allow-null-value
					/>
				</div>
			</CCol>
			<CCol md="12">
				<hr class="mt-3">
			</CCol>
			<CCol md="12">
				<BannerDate
					ref="date"
					margin-top="mt-3"
					:status="true"
					:required-end-time="true"
					:start-date="startDate"
					:start-time="startTime"
					:end-date="endDate"
					:end-time="endTime"
					@update:startDate="startDate = $event"
					@update:startTime="startTime = $event"
					@update:endDate="endDate = $event"
					@update:endTime="endTime = $event"
				/>
			</CCol>
		</CRow>
		<BaseActionPanelStickyFooter
			:disabled-confirm="isSubmitting"
			:remove-text="isEdit ? 'Remove plan' : null"
			content-class="main-wrapper"
			:is-edit="isEdit"
			@onRemove="isEdit ? $refs['modal-remove'].open() : null"
			@onConfirm="handleSubmit"
			@onCancel="redirectToPaymentSetting"
		/>
		<BaseModalConfirmDelete
			ref="modal-remove"
			:handle-remove="deleteInstallmentPlan.bind(null, { methodId: methodId, planId: this.$route.params.planId })"
			title="Remove this installment plan?"
			description="By removing this, the installment plan and condition will be removed from the system and will no longer available for customers on the BNN website."
			@onSuccess="redirectToPaymentSetting"
		/>
		<ModalSkuList
			ref="modal-sku"
			title="Exclude SKUs"
			:sku-list="skuList"
			@onConfirm="handleSKUChange"
		/>
		<ModalCategory
			ref="modal-category"
			:is-require-select="!isAllCategory"
			:selected-ids="categoryIds"
			title="Available for categories"
			@onSubmit="handleSubmitCategory"
			@onCancel="handleCancelCategoryModal"
		/>
	</form>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapActions, mapGetters } from 'vuex';
import { required, requiredIf, minValue, helpers, maxLength } from 'vuelidate/lib/validators';
import BannerDate from '@/components/BannerDate.vue';
import ModalSkuList from '@/components/ModalSkuList.vue';
import ModalCategory from '@/components/ModalCategory.vue';
import { multipleNumber } from '../regex/general';
import {
	INSTEREST_RATE_KBANK_OPTIONS,
	INSTEREST_RATE_DEFAULT_OPTIONS,
	PAYMENT_GATEWAY,
	TYPE_PLAN_LIST,
	TYPE_PLAN_VALUE,
	AVAILABLE_SKU_OPTIONS,
} from '../enums/payments';
import {
	priceToAPI,
	numberDecimalFormat,
	isBAYBankAgent,
	isKTCBankAgent,
	convertDateTimeToUTC,
} from '../assets/js/helpers';
import { MARKETING_CAMPAIGN_PERIOD_VALUE } from '../enums/marketings';

export default {
	name: 'FormInstallmentPlanKTC',
	components: {
		BannerDate,
		ModalSkuList,
		ModalCategory,
	},

	validations() {
		return {
			localInterest: {
				required,
			},
			localPeriod: {
				required,
				minValue: minValue(1),
			},
			localBrandCode: {
				required: requiredIf(() => this.isBAYBankAgent),
			},
			localCampaignCode: {
				required: requiredIf(() => this.isBAYBankAgent),
			},
			localMaxOrder: {
				greaterThanMinOrder: (value, { localMinOrder, localMaxOrder }) => {
					if (!isEmpty(localMinOrder) && !isEmpty(localMaxOrder)) {
						return Number(localMaxOrder) > Number(localMinOrder);
					}

					return true;
				},
			},
			typePlan: {
				required,
			},
			planName: {
				required,
			},
			supplierId: {
				// require input type plan 01,03
				required: requiredIf(() => this.typePlan && (this.typePlan.value === TYPE_PLAN_VALUE.TYPE_PLAN_01 || this.typePlan.value === TYPE_PLAN_VALUE.TYPE_PLAN_03)),
				format: helpers.regex('number', multipleNumber),
				maxLength: maxLength(4),
			},
			productId: {
				// require input type plan 01,03
				required: requiredIf(() => this.typePlan && (this.typePlan.value === TYPE_PLAN_VALUE.TYPE_PLAN_01 || this.typePlan.value === TYPE_PLAN_VALUE.TYPE_PLAN_03)),
				format: helpers.regex('number', multipleNumber),
				maxLength: maxLength(4),
			},
		};
	},
	props: {
		isSubmitting: {
			type: Boolean,
			default: false,
		},
		methodId: {
			type: [String, Number],
			default: null,
		},
		groupId: {
			type: [String, Number],
			default: null,
		},
		agent: {
			type: String,
			default: null,
		},
		channelId: {
			type: [String, Number],
			default: null,
		},
		brandId: {
			type: [String, Number],
			default: null,
		},
		interest: {
			type: Number,
			default: null,
		},
		period: {
			type: Number,
			default: null,
		},
		minOrderAmount: {
			type: String,
			default: null,
		},
		maxOrderAmount: {
			type: String,
			default: null,
		},
		brandCode: {
			type: String,
			default: null,
		},
		campaignCode: {
			type: String,
			default: null,
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
		gateway: {
			type: String,
			default: null,
		},
		customAttributes: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			localPeriod: null,
			localInterest: null,
			localMinOrder: null,
			localMaxOrder: null,
			localBrandCode: null,
			localCampaignCode: null,
			// for com7
			TYPE_PLAN_LIST,
			TYPE_PLAN_VALUE,
			AVAILABLE_SKU_OPTIONS,
			typePlan: null,
			planName: null,
			supplierId: null,
			productId: null,
			isAllCategory: true,
			startDate: null,
			startTime: '00:00',
			endDate: null,
			endTime: '23:59',
			skuList: [],
			categories: [],
			periodStatus: null,
		};
	},
	computed: {
		interestRateOptions() {
			if (this.gateway === PAYMENT_GATEWAY.KBANK) {
				return INSTEREST_RATE_KBANK_OPTIONS;
			}

			return INSTEREST_RATE_DEFAULT_OPTIONS;
		},
		title() {
			return this.isBAYBankAgent ? 'Plan condition' : 'Plan info';
		},
		description() {
			return this.isBAYBankAgent
				? 'Set interest rate and payment period for this plan. The condition can\'t be duplicated with other existing plans.'
				: `Currently, we offer customers up to 36-months installment plan (terms depend on the chosen bank). e.g. ${this.isKTCBankAgent ? 'KTC' : 'Kbank'} fixed at 3, 6 or 10 months with monthly interest at 0.8%`;
		},
		isBAYBankAgent() {
			return isBAYBankAgent(this.agent);
		},
		isKTCBankAgent() {
			return isKTCBankAgent(this.agent);
		},
		maxOrderErrorMessage() {
			if (!this.$v.localMaxOrder.greaterThanMinOrder) {
				return `Maximum order should be more than ${numberDecimalFormat(this.localMinOrder)}`;
			}

			return null;
		},
		isDisabledStartDate() {
			return this.isEdit && [
				MARKETING_CAMPAIGN_PERIOD_VALUE.ONGOING,
				MARKETING_CAMPAIGN_PERIOD_VALUE.EXPIRED,
			].includes(this.periodStatus);
		},
		categoryIds() {
			return this.categories.map((category) => category.id);
		},
		promotionType() {
			if (this.typePlan) {
				return `${this.typePlan.name} - ${this.typePlan.label}`;
			}
			return '';
		},
		supplierLabel() {
			if (this.typePlan && (this.typePlan.value === TYPE_PLAN_VALUE.TYPE_PLAN_01 || this.typePlan.value === TYPE_PLAN_VALUE.TYPE_PLAN_03)) {
				return 'Supplier ID *';
			}
			return 'Supplier ID';
		},
		productLabel() {
			if (this.typePlan && (this.typePlan.value === TYPE_PLAN_VALUE.TYPE_PLAN_01 || this.typePlan.value === TYPE_PLAN_VALUE.TYPE_PLAN_03)) {
				return 'Product ID *';
			}
			return 'Product ID';
		},
		...mapGetters({
			installmentPlan: 'payments/installmentDetails',
		}),
	},
	mounted() {
		if (this.isEdit) {
			this.localInterest = numberDecimalFormat(this.interest, 2);
			this.localPeriod = this.period;
			this.localMinOrder = this.minOrderAmount;
			this.localMaxOrder = this.maxOrderAmount;
			this.localBrandCode = this.customAttributes.brandCode;
			this.localCampaignCode = this.customAttributes.campaignCode;
			// EDU-3567 set data for installment plan com7
			this.planName = this.installmentPlan.planName;
			this.isAllCategory = this.installmentPlan.planName;
			this.startDate = this.installmentPlan.startDate;
			this.startTime = this.installmentPlan.startTime;
			this.endDate = this.installmentPlan.endDate;
			this.endTime = this.installmentPlan.endTime;
			this.skuList = this.installmentPlan.skuList;
			this.periodStatus = this.installmentPlan.periodValue;
			this.isAllCategory = !this.installmentPlan.isCustomCategory; // if (isCustomCategory == false) isAllCategory = true;
			this.categories = this.installmentPlan.categories;
			this.preSelectCategories(this.categoryIds);

			if (this.installmentPlan.customAttributes) {
				this.supplierId = this.installmentPlan.customAttributes.supplierId;
				this.productId = this.installmentPlan.customAttributes.productId;
				this.typePlan = this.installmentPlan.customAttributes.promotionType;
				if (this.typePlan) {
					this.setSelectedNewType(this.typePlan);
				}
			}
		}
	},
	methods: {
		...mapActions({
			deleteInstallmentPlan: 'payments/deleteInstallmentPlan',
			preSelectCategories: 'categorySelector/preSelectCategories',
		}),
		...mapGetters({
			getSelectedCategories: 'categorySelector/getSelectedCategories',
		}),
		handleSubmit() {
			this.$v.$touch();
			this.$refs.date.$v.$touch(); // required date
			if (this.$v.$invalid || this.$refs.date.$v.$invalid) {
				return;
			}
			const params = {
				interest_rate: this.localInterest,
				period: this.localPeriod,
				min_order_amount: priceToAPI(this.localMinOrder),
				max_order_amount: priceToAPI(this.localMaxOrder),
				...(
					this.isBAYBankAgent
						? { custom_attributes: { brand_code: this.localBrandCode, campaign_code: this.localCampaignCode } }
						: null
				),
				is_default_plan: true,
				started_at: convertDateTimeToUTC(this.startDate, this.startTime),
				ended_at: convertDateTimeToUTC(this.endDate, this.endTime),
				name: this.planName,
				custom_attributes: {
					promotion_type: this.typePlan ? this.typePlan.value : undefined,
					supplier_id: this.supplierId,
					promotion_product_id: this.productId,
					absorption_type: 'custom', // BNN-9214 hard code params custom for Instament plan KTC
				},
				is_custom_category: !this.isAllCategory,
				category_ids: !this.isAllCategory ? this.categoryIds : [],
				excluded_product_skus: !this.isAllCategory ? this.skuList : [],
			};
			this.$emit('onSubmit', params);
		},
		redirectToPaymentSetting() {
			if (this.brandId) {
				this.$router.push({
					name: 'BrandInstallmentPlanEdit',
					params: {
						id: this.groupId,
						methodId: this.methodId,
						brandId: this.brandId,
					},
				});
			} else if (this.channelId) {
				this.$router.push({
					name: 'InstallmentPlanChannel',
					params: {
						id: this.groupId,
						methodId: this.methodId,
						channelId: this.channelId,
					},
				});
			} else {
				this.$router.push({
					name: 'PaymentMethodSetting',
					params: {
						id: this.groupId,
						methodId: this.methodId,
					},
				});
			}
		},
		handleRemovePlan() {
			this.redirectToPaymentSetting();
		},
		handleChooseOptions(value) {
			this.isAllCategory = value;
		},
		setSelectedNewType(newType) {
			this.$v.typePlan.$model = TYPE_PLAN_LIST.find((plan) => plan.value === newType);
		},
		handleSKUChange(skus = []) {
			this.skuList = [...skus];
		},
		handleSubmitCategory(categories = []) {
			this.categories = categories;
		},
		handleCancelCategoryModal() {
			// Reset category data when user close/cancel category modal
			this.preSelectCategories(this.categoryIds);
		},
	},
};
</script>

<style lang="scss" scoped>
	::v-deep .input-period {
		.form-control-number {
			// override padding left append text
			padding-right: rem(60) !important;
		}
	}
</style>
